import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  getAllPromptsList: [],
  getLlMVersionsList: [],
  getPromptById: {},
  getConditionPrompt: [],
  PromptScreenCondition: [],

  prompts: [],
  promptsLoading: false,
  prompt: {},
  promptLoading: false,

  llms: [],
  llmsLoading: false,
  promptScreens: [],
  promptScreensLoading: false,
};

const promptSlice = createSlice({
  name: 'promptSlice',
  initialState,
  reducers: {
    getAllPromptsListSlice: (state, { payload }) => {
      state.getAllPromptsList = payload;
    },
    getLLmVersionSlice: (state, { payload }) => {
      state.getLlMVersionsList = payload;
    },
    getPromptsByIdSlice: (state, { payload }) => {
      state.getPromptById = payload;
    },
    getPromptScreensSlice: (state, { payload }) => {
      state.promptScreens = payload;
    },
    getConditionPromptSlice: (state, { payload }) => {
      state.getConditionPrompt = payload;
    },
    getPromptScreenConditionSlice: (state, { payload }) => {
      state.PromptScreenCondition = payload;
    },
    // v2 state
    listPromptsSlice: (state, { payload }) => {
      state.prompts = payload;
    },
    getPromptSlice: (state, { payload }) => {
      state.prompt = payload;
    },
    listPromptsLoadingSlice: (state, { payload }) => {
      state.promptsLoading = payload;
    },
    getPromptLoadingSlice: (state, { payload }) => {
      state.promptLoading = payload;
    },
    listLlmsSlice: (state, { payload }) => {
      state.llms = payload;
    },
    listLlmsLoadingSlice: (state, { payload }) => {
      state.llmsLoading = payload;
    },
    listPromptScreensSlice: (state, { payload }) => {
      state.promptScreens = payload;
    },
    listPromptScreensLoadingSlice: (state, { payload }) => {
      state.promptScreensLoading = payload;
    },
  },
});

const { actions, reducer } = promptSlice;

export const {
  getAllPromptsListSlice,
  getLLmVersionSlice,
  getPromptsByIdSlice,
  getPromptScreensSlice,
  getConditionPromptSlice,
  getPromptScreenConditionSlice,
  listPromptsSlice,
  listPromptsLoadingSlice,
  getPromptLoadingSlice,
  getPromptSlice,
  listLlmsSlice,
  listLlmsLoadingSlice,
  listPromptScreensSlice,
  listPromptScreensLoadingSlice,
} = actions;

export default reducer;
